








































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { useQuery } from '@vue/apollo-composable';

import deliveryNotes from '@/table/cashFlow/deliveryNotes';
import getDeliveryNotes from '@/gql/cashflow/getDeliveryNotesCashflow.gql';
import getDeliveryNotesCashflowStats from '@/gql/cashflow/getDeliveryNotesCashflowStats.gql';

const CashflowDeliveryNoteList = defineComponent({
  setup() {
    const toCurrency = (str: string | number) => useFormat.number(str).currency();
    const toCommaFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const filter = reactive({
      deliveryDate: {
        from: undefined,
        to: undefined,
      },
      text: '',
    });
    function clickDateHandler(date: any) {
      if (filter.deliveryDate.from === useFormat.date(date).computerShortDate()) {
        filter.deliveryDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.deliveryDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }

    const getDeliveryNotesResult = (data: any) => data.deliveryNotes;
    const deliveryNotesVariables = computed(() => {
      const vars: {[key: string]: any} = {
        searchDeliveryNoteId: undefined,
        filterDeliveryDateBetween: undefined,
      };
      if (filter.text) {
        vars.searchDeliveryNoteId = `%${filter.text}%`;
      }
      if (filter.deliveryDate.from) {
        vars.filterDeliveryDateBetween = filter.deliveryDate;
      }
      return vars;
    });

    const { result: cashFlowStatsResult } = useQuery(getDeliveryNotesCashflowStats, () => ({ fetchPolicy: 'network-only' }));
    const cashFlowStats = computed(() => {
      const result = cashFlowStatsResult.value || {
        cashFlowStats: { sumByMonths: [] },
        deliveryNotes: { paginatorInfo: { total: 0 } },
      };
      let total = 0;
      (result?.cashFlowStats?.sumByMonths || []).forEach((val: any) => {
        total += val.sum;
      });

      return {
        total,
        totalDN: result?.deliveryNotes?.paginatorInfo?.total || 0,
      };
    });

    return {
      toCurrency,
      toCommaFormat,

      clickDateHandler,
      getDeliveryNotes,
      filter,
      deliveryNotes,
      getDeliveryNotesResult,
      deliveryNotesVariables,
      cashFlowStats,
    };
  },
});

export default CashflowDeliveryNoteList;
